import morningImg from "src/assets/images/moring-icon.png";
import evneningImg from "src/assets/images/evnening-icon.png";
import nightImg from "src/assets/images/night-icon.png";
import { IDropDownArray, IHomecareAppointDetail } from "src/types/GlobalInterfaces";
import { useWindowSize } from "src/helpers/helperFunctions";
import morningImgActive from "src/assets/images/website-images/mornig-white.png";
import evneningImgActive from "src/assets/images/website-images/even-active.png";
import nightImgActive from "src/assets/images/website-images/night-active.png";
export const GOOGLE_API_KEY = "AIzaSyAAMOjFJE6Q9oUMm6Vgbv25WXhEG_IlC3U";

export const ImageBaseUrl = "";

export const ageGroup: { title: string; age: string }[] = [
  { title: "child", age: "0-18" },
  { title: "adult", age: "19-49" },
  { title: "elder", age: "50+" },
];

export const statusColor = {
  yellow: "#dcc44b",
  green: "#0a9830",
  red: "#f00000",
};

export const doctorMode = "isDoctorOrCustomer";
export const CURRENCY = "PKR";
export const FREE_DELIVERY_AMOUNT = 2200;
export const utcOffset = 4; // for utc

export const CART_COOKIE_KEY = "cart_items";
export const ADDRESS_COOKIE_KEY = "shipping_addresses";

export const twoFactorKey = "twoFactor";
export const customer = "customer";
export const practitioner = "practitioner";
export const superAdmin = "superAdmin";
export const operator = "operator";
export const admin = "admin";
export const editor = "editor";
export const doctor = "doctor";
export const active = "active";
export const inactive = "inactive";
export const pending = "pending";
export const declined = "declined";
export const currencySymbol = "A$";
export const clientToken = "TOKEN";
export const adminToken = "ADMIN_TOKEN";
export const countryCode = "+61";
export const dateTime = "YYYY-MM-DD hh:ss A";
export const CHECKBOX_INPUT = "CHECKBOX_INPUT";

// errors
export const unexpectedError = "Unexpected server error.";
export const validationError = "Form validation error.";

// validation messages
export const errMsg = {
  required: "Value is required",
  onlyLetters: "Value must contain only letters",
  noSpace: "Value must contain only letters and no spacing.",
  notMatched: "Value did not match.",
  invalidEmail: "Must be a valid email address.",
  length3to16: "Value must be between 3 and 16 characters",
  onlyNumbers: "Value must contain only numbers",
  ph: "Start with 61, include numbers, length 11.",
  invalidPassword:
    "Password pattern: 1 lowercase, 1 uppercase, 1 digit, 1 special, atleast 8 characters ",
};

export const EXPRESS_DELIVERY_CHARGE = 230;
export const STANDARD_DELIVERY_CHARGE = 0;

export const findAge = (age: string): number => {
  return 1;
};

export const barColors = {
  red: "#FF0000",
  orange: "#EDAA5D",
  yellow: "#ffff17",
  green: "#46B710",
};
export const barColorsLight = {
  red: "#fcd8d8",
  orange: "#fceac6",
  yellow: "#ffffd2",
  green: "#d1e5d0",
};

export const fiveBarMarker = "fiveBarMarker"; // red, orange, green, orange, red, // opt min & opt max, will ly b/w ref min & ref max. any value should not be the same.
export const fourBarMarkerAsc = "fourBarMarkerAsc"; // red, orange, yellow, green // opt max will be the same as ref max, opt min will ly b/w ref min & ref max
export const fourBarMarkerDesc = "fourBarMarkerDesc"; //green, yellow, orange, red // opt min & ref min will be the same & opt max will ly b/w ref min & ref max
export const threeBarMarkerCentralized = "threeBarMarkerCentralized"; // red, green, red // opt min & ref min will be the same & opt max & ref max will be the same
export const threeBarMarkerAsc = "threeBarMarkerAsc"; // red, orange, green // opt min & ref max will be the same & ref min is less then ref max & opt max is greater than opt min
export const threeBarMarkerDesc = "threeBarMarkerDesc"; // green, orange, red // opt max & ref min will be the same & opt min will be less then opt max & ref max will always be greater then ref min.
export const twoBarMarkerAsc = "twoBarMarkerAsc"; // red, green //  opt min & ref min will be the same & opt max & ref max will be the same
export const twoBarMarkerDesc = "twoBarMarkerDesc"; // green, red //  opt min & ref min will be the same & opt max & ref max will be the same
export const twoBarDNDAsc = "twoBarDNDAsc"; // red, green // detected & not detected
export const twoBarDNDDesc = "twoBarDNDDesc"; // green, red // detected & not detected
export const twoBarPNAsc = "twoBarPNAsc"; // red, green // positive & negative
export const twoBarPNDesc = "twoBarPNDesc"; // green, red // positive & negative
export const descriptiveResult = "descriptiveResult"; // only input field

export const positive = "Positive";
export const negative = "Negative";
export const detected = "Detected";
export const notDetected = "Not Detected";

export const allMonths = [
  { month: 1, name: "Jan" },
  { month: 2, name: "Feb" },
  { month: 3, name: "Mar" },
  { month: 4, name: "Apr" },
  { month: 5, name: "May" },
  { month: 6, name: "Jun" },
  { month: 7, name: "Jul" },
  { month: 8, name: "Aug" },
  { month: 9, name: "Sep" },
  { month: 10, name: "Oct" },
  { month: 11, name: "Nov" },
  { month: 12, name: "Dec" },
];

// Generate a list of years from startYear to endYear
const startYear: number = 2024; // Adjust as needed birth year
export const currentYear: number = new Date().getFullYear();
export const allYears = Array.from(
  { length: currentYear - startYear + 1 },
  (_, i) => startYear + i
);

export const weekDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];
export const appointmentSlots: {
  key: "morning" | "afternoon" | "evening" | "night";
  title: string;
  time: string;
  image: string;
  imageActive: string;
}[] = [
  {
    key: "morning",
    title: "Morning",
    time: "08:00 AM - 12:00 PM",
    image: morningImg,
    imageActive: morningImgActive,
  },
  {
    key: "afternoon",
    title: "Afternoon",
    time: "12:00 PM - 04:00 PM",
    image: morningImg,
    imageActive: morningImgActive,
  },
  {
    key: "evening",
    title: "Evening",
    time: "04:00 PM - 08:00 PM",
    image: evneningImg,
    imageActive: evneningImgActive,
  },
  {
    key: "night",
    title: "Night",
    time: "08:00 PM - 12:00 AM",
    image: nightImg,
    imageActive: nightImgActive,
  },
];

// Dynamic slots generator function
export interface IDynamicSlot {
  key: string;
  title: string;
  time: string;
  label: string;
  image: string;
  imageActive: string;
  isPassed: boolean;
  afterOneHours: boolean;
  period: "morning" | "afternoon" | "evening" | "night";
  isAlreadySelected: boolean;
}

export interface IOrganizedSlots {
  morning: IDynamicSlot[];
  afternoon: IDynamicSlot[];
  evening: IDynamicSlot[];
  night: IDynamicSlot[];
}

export const generateDynamicSlots = (hours: number , selectedDate: string, editData?: IHomecareAppointDetail | null): IOrganizedSlots => {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const currentTimeInMinutes = currentHour * 60 + currentMinute;
  
  // Check if selected date is today
  const selectedDateObj = new Date(selectedDate);
  const today = new Date();
  const selectedDateStr = selectedDateObj.toISOString().split("T")[0];
  const todayStr = today.toISOString().split("T")[0];
  const isToday = selectedDateStr === todayStr;
  
  // Start from 8 AM (8 * 60 = 480 minutes)
  const startHour = 8;
  const endHour = 22; // 10 PM
  
  const organizedSlots: IOrganizedSlots = {
    morning: [],
    afternoon: [],
    evening: [],
    night: []
  };
  
  for (let hour = startHour; hour < endHour; hour += hours) {
    const startTimeInMinutes = hour * 60;
    const endTimeInMinutes = (hour + hours) * 60;
    
    // Check if slot has passed (only for today's date)
    const isPassed = isToday ? currentTimeInMinutes > startTimeInMinutes : false;
    
    // Check if slot is within 1 hour (afterOneHours) - only for today
    const oneHourFromNow = currentTimeInMinutes + 60;
    const afterOneHours = isToday ? startTimeInMinutes < oneHourFromNow : false;
    
    // Format time strings
    const startTime = formatTime(hour);
    const endTime = formatTime(hour + hours);
    const timeString = `${startTime} - ${endTime}`;
    const labelString = `${formatTimeForLabel(hour)} - ${formatTimeForLabel(hour + hours)}`;
    
    // Determine period and images based on time of day
    const { image, imageActive, period } = getTimeSlotDetails(hour);
    
    const slot: IDynamicSlot = {
      key: `slot_${hour}_${hour + hours}`,
      title: `${hours} Hour Slot`,
      time: timeString,
      label: labelString,
      image,
      imageActive,
      isPassed,
      afterOneHours,
      period,
      isAlreadySelected: editData?.timeslot === timeString && editData.appointmentDate === selectedDate
    };
    
    // Add to appropriate period array
    organizedSlots[period].push(slot);
  }
  
  return organizedSlots;
};

// Helper function to format time (24-hour to 12-hour with AM/PM)
const formatTime = (hour: number): string => {
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour.toString().padStart(2, '0')}:00 ${period}`;
};

// Helper function to format time for label (8pm, 9am format)
const formatTimeForLabel = (hour: number): string => {
  const period = hour >= 12 ? 'pm' : 'am';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour}${period}`;
};

// Helper function to get appropriate images and period based on time
const getTimeSlotDetails = (hour: number): { 
  image: string; 
  imageActive: string; 
  period: "morning" | "afternoon" | "evening" | "night" 
} => {
  if (hour >= 8 && hour < 12) {
    return { 
      image: morningImg, 
      imageActive: morningImgActive, 
      period: "morning" 
    };
  } else if (hour >= 12 && hour < 16) {
    return { 
      image: morningImg, 
      imageActive: morningImgActive, 
      period: "afternoon" 
    };
  } else if (hour >= 16 && hour < 20) {
    return { 
      image: evneningImg, 
      imageActive: evneningImgActive, 
      period: "evening" 
    };
  } else {
    return { 
      image: nightImg, 
      imageActive: nightImgActive, 
      period: "night" 
    };
  }
};



export function isTimeSlotPassed(selectedDate: Date, slotKey: "morning" | "afternoon" | "evening" | "night"): boolean {
  const slot = appointmentSlots.find(slot => slot.key === slotKey);
  if (!slot) {
    throw new Error("Invalid slot key");
  }

  const now = new Date();
  const today = new Date();
  const selectedDateStr = selectedDate.toISOString().split("T")[0];
  const todayStr = today.toISOString().split("T")[0];
  
  // If selected date is not today, slot is not passed (available for future dates)
  if (selectedDateStr !== todayStr) {
    return false;
  }

  const endTimeStr = slot.time.split(" - ")[1].trim();
  let endHour = parseInt(endTimeStr.split(":")[0]);
  const endMinute = parseInt(endTimeStr.split(":")[1].split(" ")[0]);
  const isPM = endTimeStr.toLowerCase().includes("pm");

  // Convert to 24-hour format
  if (isPM && endHour !== 12) {
    endHour += 12;
  } else if (!isPM && endHour === 12) {
    endHour = 0;
  }

  // Adjust for "Night" slot crossing midnight
  let slotEndTime = new Date(`${selectedDateStr}T${endHour.toString().padStart(2, "0")}:${endMinute.toString().padStart(2, "0")}:00`);
  if (slotKey === "night" && endHour === 0) {
    // For "Night" slot, move to the next day if end time is 12:00 AM
    slotEndTime.setDate(slotEndTime.getDate() + 1);
  }

  return now > slotEndTime;
}

export const TimeConvertorToLable = (val: string) => {
  let tm: { [key: string]: string } = {
    "08:00 AM - 12:00 PM": "8am - 12pm",
    "12:00 PM - 04:00 PM": "12pm - 4pm",
    "04:00 PM - 08:00 PM": "4pm - 8pm",
    "08:00 PM - 12:00 AM": "8pm - 12am",
  };
  return tm[val];
};

export const NewInputUiStyles = {
  borderColor: "#ACACAC",
  borderRadius: 10,
};

export const availabilityList: IDropDownArray[] = [
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
  { label: "Sunday", value: "sunday" },
];

export const ResponsiveGrid = {
  "2xl": { cols: 4, gap: 4 },
  xl: { cols: 4, gap: 4 },
  lg: { cols: 3, gap: 1.5 },
  md: { cols: 2, gap: 1.5 },
  sm: { cols: 1, gap: 1.5 },
  xs: { cols: 1, gap: 1.5 },
};

// export const getFetchProductLimit = () => {
//   const { width } = useWindowSize();
//   if (width >= 1536) return 4;
//   if (width >= 1280) return 3;
//   if (width >= 1024) return 2;
//   if (width >= 768) return 1;
//   return 1;
// };

// All Regex Constants
// Phone number validation: with + = 13 chars total (+ and 12 digits), without + = 11 digits
export const phoneNumberRegex = /^(?:\+[\d]{12}|[\d]{11})$/;
// Allows: +923001234567 (with + = 12-14 digits), 03001234567 (without + = 10-11 digits)
// Disallows: +92300123456 (with + but less than 12 digits), spaces, special chars

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// Allows: user.name@domain.com, user_name@sub.domain.co
// Disallows: spaces, invalid domains, missing @ or .

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;
// Requires: 8-20 chars, 1 lowercase, 1 uppercase, 1 digit, 1 special char (@$!%*?&)
// Disallows: spaces, other special chars

export const nameRegex = /^(?=.{3,30}$)[a-zA-Z]+(\s[a-zA-Z]+)*$/;
// Allows: Letters with optional spaces, 3-30 chars (e.g., "Ali", "Ali Khan", "Muhammad Ali Khan")
// Disallows: Numbers, special chars, starting/ending with space, consecutive spaces, less than 3 or more than 30 chars

export const addressRegex = /^[a-zA-Z0-9\s.,#-]{5,100}$/;
// Allows: Alphanumeric, spaces, commas, periods, #, -, 5-100 chars
// Disallows: Other special chars, too short/long

export const cityRegex = /^[a-zA-Z\s]{2,50}$/;
// Allows: Letters and spaces, 2-50 chars (e.g., "Karachi")
// Disallows: Numbers, special chars, too short/long

export const stateRegex = /^[a-zA-Z\s]{2,50}$/;
// Allows: Letters and spaces, 2-50 chars (e.g., "Sindh")
// Disallows: Numbers, special chars, too short/long

export const zipCodeRegex = /^[0-9]{6}$/;
// Allows: Exactly 6 digits (e.g., "123456")
// Disallows: Letters, special chars, wrong length

export const countryRegex = /^[a-zA-Z\s]{2,50}$/;
// Allows: Letters and spaces, 2-50 chars (e.g., "Pakistan")
// Disallows: Numbers, special chars, too short/long

export const flatVillaNoRegex = /^[a-zA-Z0-9\s,\/-]{1,20}$/;
// Allows: Letters, numbers, spaces, commas, /, -, 1-20 chars (e.g., "Flat 101", "A-12", "Villa, 5")
// Disallows: Other special chars, too long

export const buildingNameRegex = /^[a-zA-Z0-9\s,-]{1,50}$/;
// Allows: Letters, numbers, spaces, commas, dashes, 1-50 chars (e.g., "Tower A, Building 1", "Complex-2")
// Disallows: Other special chars, too long

export const landmarkRegex = /^[a-zA-Z0-9\s,\/-]{1,100}$/;
// Allows: Letters, numbers, spaces, commas, dashes, slashes, 1-100 chars (e.g., "Near Mall, Block A", "Area-1/2")
// Disallows: Other special chars, too long

export const streetAddressRegex = /^[a-zA-Z0-9\s,\-#\/\.+]{10,100}$/;
// Allows: Letters, numbers, spaces, commas, periods, dashes, slashes, hash (#), plus (+), 10-100 chars
// Valid Examples: "House 24-B, Street 7, Gulshan-e-Iqbal", "Flat #301, Block-5, Clifton, Karachi", "Plot 12/3, Phase-4, DHA"
// Google Maps Examples: "123 Main St + Block A", "Building +1, Street 5"
// Disallows: Colons (:), semicolons (;), junk symbols (@@, ^^), too short (less than 10 chars)

// Pakistan Banking Validation Regex
export const pakistanSwiftCodeRegex = /^[A-Z]{4}PK[A-Z0-9]{2}([A-Z0-9]{3})?$/;
// Pakistan SWIFT/BIC Code format: AAAA BB CC DDD (8 or 11 characters, no spaces in validation)
// 8 chars: AAAA BB CC (Bank + Country + Location)
// 11 chars: AAAA BB CC DDD (Bank + Country + Location + Branch)
// Example: HABBPKKA (8 chars) or HABBPKKAXXX (11 chars)

export const pakistanBranchCodeRegex = /^[0-9]{4}$/;
// Pakistan Bank Branch Code: exactly 4 digits only
// Example: 1234

export const pakistanAccountNumberRegex = /^[0-9]{10,16}$/;
// Pakistan Bank Account Number: 10-16 digits only
// Example: 1234567890, 1234567890123456

export const pakistanIbanRegex = /^PK\d{2}[A-Z]{4}\d{16}$/;
// Pakistan IBAN format: PK + 2 digits + 4 digits + 16 digits = 24 characters total
// Example: PK321412341234123412341234

export const pakistanTidRegex = /^[A-Z0-9]{8,20}$/;
// Pakistan Transaction ID (TID) format: 8-20 alphanumeric characters
// Common formats:
// - HBL: 12-16 digits (e.g., 123456789012)
// - UBL: 10-12 alphanumeric (e.g., UBL123456789)
// - MCB: 8-12 digits (e.g., 12345678)
// - Allied: 10-15 alphanumeric (e.g., ABL123456789)
// - Standard Chartered: 12-16 alphanumeric (e.g., SCB123456789012)
// - Meezan: 10-14 alphanumeric (e.g., MZB1234567890)
// - Askari: 8-12 digits (e.g., 12345678)
// - JS Bank: 10-12 alphanumeric (e.g., JS123456789)
// - Faysal: 10-14 alphanumeric (e.g., FBL1234567890)

// Query Url Constants
export const QueryPath = {
  brand: "sh-bid",
  brandName: "sh-bname",
  tag: "sh-ptid",
  tagName: "sh-ptname",
  mainCategory: "sh-mcid",
  mainCategoryName: "sh-mcname",
  subCategory: "sh-scid",
  subCategoryName: "sh-scname",
  childCategory: "sh-ccid",
  childCategoryName: "sh-ccname",
  promotionalTag: "sh-ptid",
  promotionalTagName: "sh-ptname",
  productTag: "sh-ptid",
  productTagName: "sh-ptname",
  labTestCategory: "sh-ltcid",
  labTestCategoryName: "sh-ltcname",
  homeCareCategory: "sh-hcid",
  homeCareCategoryName: "sh-hcname",
  specialization: "sh-sid",
  specializationName: "sh-sname",
  search: "sh-search",
};

export const stripeCardNumberInputStyles = {
  style: {
    base: {
      fontSize: "14px",
      fontFamily: "Poppins, sans-serif",
      color: "#000",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
  },
};


export const CartItemToast = {
  success: {
    "diagnostic-product": "Lab test added to cart",
    "diagnostic-package": "Health package added to cart",
    "pharmacy-product": "Pharmacy product added to cart",
  },
  error: {
    "diagnostic-product": "Error adding lab test to cart",
    "diagnostic-package": "Error adding health package to cart",
    "pharmacy-product": "Error adding pharmacy product to cart",
  },
  delete: {
    "diagnostic-product": "Lab test removed from cart",
    "diagnostic-package": "Health package removed from cart",
    "pharmacy-product": "Pharmacy product removed from cart",
  },
  deleteError: {
    "diagnostic-product": "Error removing lab test from cart",
    "diagnostic-package": "Error removing health package from cart",
    "pharmacy-product": "Error removing pharmacy product from cart",
  },
}